module.exports = __webpack_public_path__ + "media/customizations/lmdb/back-b362a4fce30b2ea93822da82bc6a2524.jpg";